<template>
  <div v-if="paginationInfo && (paginationInfo.last_page > 1)" class="p-pagination">
    <div class="p-pagination-summary">
      <span class="p-pagination-summary__text">全</span>
      <span class="p-pagination-summary__value p-pagination-summary__value--total">{{ paginationInfo.total }}</span>
      <span class="p-pagination-summary__text">件中、</span>
      <span class="p-pagination-summary__value p-pagination-summary__value--from">{{ paginationInfo.from }}</span>
      <span class="p-pagination-summary__value p-pagination-summary__value--to">{{ paginationInfo.to }}</span>
      <span class="p-pagination-summary__text">件を表示しています</span>
    </div>
    <ul class="p-pagination-list">
      <li class="p-pagination-list__item p-pagination-list__item--first">
        <a href="#" @click="onPageClick($event,1)"></a>
      </li>
      <li class="p-pagination-list__item p-pagination-list__item--prev">
        <a href="#" @click="onPageClick($event,paginationInfo.current_page-1)"></a>
      </li>

      <template v-for="(n,index) in numberOfElements" :key="index">
        <li v-if="getPage(index)" class="p-pagination-list__item" :class="getPage(index) == paginationInfo.current_page ? 'is-active' : ''">
          <a v-if="getPage(index) != paginationInfo.current_page" href="#" @click="onPageClick($event,getPage(index))">{{ getPage(index) }}</a>
          <template v-else>{{ getPage(index) }}</template>
        </li>
      </template>

      <li class="p-pagination-list__item p-pagination-list__item--next">
        <a href="#" @click="onPageClick($event,paginationInfo.current_page+1)"></a>
      </li>
      <li class="p-pagination-list__item p-pagination-list__item--last">
        <a href="#" @click="onPageClick($event,paginationInfo.last_page)"></a>
      </li>
    </ul>
  </div>
</template>

<script>
import 'axios';

export default {
  props: {
    paginationInfo: Object,
  },
  emits: ["on-page-click"],
  data () {
    return {
      numberOfElements: 3, // 奇数
    }
  },
  methods: {
    // ボタン位置に対応したページ番号を返す
    getPage: function(index) {
      let left = Math.floor((this.numberOfElements - 1) / 2);
      (this.numberOfElements - left - 1);
      let first = this.paginationInfo.current_page - left;
      if(first <= 0){
        first = 1;
      }
      let last = first + this.numberOfElements - 1;
      if(this.paginationInfo.last_page < last){
        first -= last - this.paginationInfo.last_page;
        if(first < 0){
          first = 1;
        }
      }
      let page = first + index;
      if(this.paginationInfo.last_page < page){
        page = 0;
      }
      return page;
    },
    // ボタンがクリックされた場合親のイベントをキックする
    onPageClick: function(event,page) {
      event.preventDefault();
      if((1 <= page) && (page <= this.paginationInfo.last_page)){
        this.$emit('on-page-click', page);
      }
    },
  },
}
</script>
